export const targets = [
	{key: 'startCash', value: 'Start Cash'},
	{key: 'basketNotional', value: 'Notional'},
]

export const cbPromptConfig = 'cb-prompt'
